// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ExemptionChangeOrigin {
  Unknown = "UNKNOWN",
  BackOffice = "BACK_OFFICE",
  VehicleRegister = "VEHICLE_REGISTER",
}
export default ExemptionChangeOrigin;
